// Envolve o callback do ResizeObserver em requestAnimationFrame para eliminar o erro benigno
// "ResizeObserver loop completed with undelivered notifications." disparado por tabelas do antd
// dentro de modais animados. DEVE ser importado ANTES de qualquer import do antd/rc-resize-observer,
// senao a biblioteca ja capturou o ResizeObserver nativo antes deste patch rodar.
if (typeof window !== 'undefined' && (window as any).ResizeObserver) {
  const ResizeObserverOriginal = (window as any).ResizeObserver;
  (window as any).ResizeObserver = class extends ResizeObserverOriginal {
    constructor(callback: ResizeObserverCallback) {
      super((entries: ResizeObserverEntry[], observer: ResizeObserver) => {
        window.requestAnimationFrame(() => {
          callback(entries, observer);
        });
      });
    }
  };
}

export {};
